import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}],["path",{"d":"M14 16v-8","key":"svg-2"}],["path",{"d":"M10 12h4","key":"svg-3"}]]

const IconHospitalCircle = createReactComponent('outline', 'hospital-circle', 'HospitalCircle', __iconNode);

export default IconHospitalCircle;